/* unplugin-vue-components disabled */import script from "./data3.vue?vue&type=script&setup=true&lang=js"
export * from "./data3.vue?vue&type=script&setup=true&lang=js"

import "./data3.vue?vue&type=style&index=0&id=0e533bc4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e533bc4"]])

export default __exports__